/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]  .invalid-feedback{display:block}[_nghost-%COMP%]   .locations[_ngcontent-%COMP%]{display:block;top:3em;border-radius:0}"];
export { styles as styles };
